/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_Once_ToastInputs */



/**
* | output |
* | --- |
* | "Selected result replaced successfully" |
*
* @param {Find_Replace_Replace_Once_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_once_toast = /** @type {((inputs?: Find_Replace_Replace_Once_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_Once_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le resultat selectionne a ete remplace avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewähltes Ergebnis erfolgreich ersetzt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il risultato selezionato è stato sostituito correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбранный результат успешно заменен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultado seleccionado reemplazado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已成功替换所选结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択した結果が正常に置き換えられました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित परिणाम सफलतापूर्वक प्रतिस्थापित हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultado selecionado substituído com sucesso")
	return /** @type {LocalizedString} */ ("Selected result replaced successfully")
});